import React, { Component } from 'react';
import './ResultConfirmPage.css';
import resultLogo from '../../img/resultLogo.png';
import location from '../../img/location.png';
import phone from '../../img/phone.png';
import clipboardTodo from '../../img/clipboardTodo.png';
import clipboard from '../../img/clipboard.png';
import success from '../../img/success.png';
import appleIco from '../../img/appleIco.png';
import googleIco from '../../img/googleIco.png';
import skariLogo from '../../img/skariLogo.png';
import GlobalStore from "../../store/GlobalStore";
import { compose, withProps } from "recompose";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import ApiConnector from "../api/ApiConnector";
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import TagManager from 'react-gtm-module';
import { config } from '../../config.js';
import ReactQueryParams from 'react-query-params';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import scrollToComponent from 'react-scroll-to-component';

if (config.environment !== "prod") {
    GlobalStore.getInstance().data['ifNewUser'] = true;
}

const fbPixelOptions = {
    autoConfig: true, 	// set pixel's autoConfig
    debug: false, 		// enable logs
};

ReactPixel.init('615166872018376', null, fbPixelOptions);
ReactGA.initialize('UA-91391382-1');

const MyMapComponent_1 = compose(
    withProps({
        googleMapURL:
            "https://maps.googleapis.com/maps/api/js?key=AIzaSyDdfgXL5Wl2Wkqt7_4ZhLrkCx7D6mVEYb8&language=fi&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    withScriptjs,
    withGoogleMap
)(() => (
    <GoogleMap defaultZoom={17} defaultCenter={{ lat: 60.2625282, lng: 24.8537106 }}>
        <Marker position={{ lat: 60.2625282, lng: 24.8537106 }} />
    </GoogleMap>
));

const MyMapComponent_2 = compose(
    withProps({
        googleMapURL:
            "https://maps.googleapis.com/maps/api/js?key=AIzaSyDdfgXL5Wl2Wkqt7_4ZhLrkCx7D6mVEYb8&language=fi&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    withScriptjs,
    withGoogleMap
)(() => (
    <GoogleMap defaultZoom={17} defaultCenter={{ lat: 60.23792383286121, lng: 24.89004183595649 }}>
        <Marker position={{ lat: 60.23792383286121, lng: 24.89004183595649 }} />
    </GoogleMap>
));

class ResultConfirmPage extends ReactQueryParams {
    constructor(props) {
        super();
        this.savePersonalData = this.savePersonalData.bind(this);
        this.state = {
            isUpdateUserInformation: false,
            loader: false
        };

        ReactGA.ga((tracker) => {
            this.analyticsClientID = tracker.get('clientId');
            console.log('client ID: ' + this.analyticsClientID);
        });
    }

    openAppleCalendar() {
        alert('Apple CLick');
    }

    openGoogleCalendar() {
        alert('Google CLick');
    }

    clearCookiesAndRestart() {
        GlobalStore.getInstance().data['currentStep'] = 1;
        GlobalStore.getInstance().data['filterDoctorName'] = undefined;
        GlobalStore.getInstance().data['filterDoctorId'] = undefined;
        window.location.reload();
    }

    componentDidMount() {
        GlobalStore.getInstance().data['currentStep'] = 5;
        //тут ми відсилаємо в dataLayer (об'єкт GoogleTagManager) подію здійсненого бронювання для аналітики


        const script = document.createElement("script");

        script.src = "https://www.googletagmanager.com/gtag/js?id=AW-947585252";
        script.async = true;

        document.body.appendChild(script);
            // window.dataLayer = window.dataLayer || [];
            function gtag(){}
            gtag('js', new Date());

            gtag('config', 'AW-947585252');

        {/*Event snippet for New app visit booked conversion page*/}
            gtag('event', 'conversion', {
            'send_to': 'AW-947585252/1a9NCNbmrHsQ5IHswwM',
            'transaction_id': ''
        });
    }

    //достає з інпутів дані і відправляє їх на API
    savePersonalData() {
        let userFullData = {
            personalEmail: this.refs.personalEmail.value,
            personalStreetName: this.refs.personalStreetName.value,
            personalCity: this.refs.personalCity.value,
            personalZipCode: this.refs.personalZipCode.value,
            personalPhone: this.refs.personalPhone.value
        };
        console.log(userFullData);
        if (userFullData.personalPhone !== '') {
            this.setState({ loader: true });

            const tagManagerArgsUniversal = {
                gtmId: 'GTM-5MHWB3M',
                dataLayer: {
                    event: 'elementHover',
                    eventCategory: 'appointment additional info saved',
                    eventAction: this.analyticsClientID,
                    eventLabel: new Date().toString() + ' ||| zip: ' + userFullData.personalZipCode
                }
            };

            if (this.queryParams.env !== "test" && config.environment === "prod") {
                TagManager.initialize(tagManagerArgsUniversal);
                ReactPixel.track(
                    'CompleteRegistration',
                    {
                        content_name: new Date().toString() + ' ||| zip: ' + userFullData.personalZipCode,
                        content_category: 'appointment additional info saved',
                        value: 15,
                        currency: 'USD',
                        referrer: document.referrer,
                        userAgent: navigator.userAgent,
                        language: navigator.language
                    });
            }

            // GlobalStore.getInstance().data['userExtendedData'] = userFullData;
            let callbackStatusUpdatingUserInformation = ApiConnector.updateUserInformation(userFullData);
            callbackStatusUpdatingUserInformation.then((() => {
                this.setState({isUpdateUserInformation: true}, () => {
                    this.isUpdateUserInformation();
                    // setTimeout(function () {
                    //     let element = document.getElementById("successUpdateUserInformation");
                    //     element.scrollIntoView({block: 'start', behavior: 'smooth'});
                    // }, 100); а шо єслі
                });
            })).catch(() => {
                this.setState({ loader: false });
                NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                    this.savePersonalData();
                });
            });

        }else {
            NotificationManager.error('Please fill the contact number field.', 'Not enough data', 5000);
        }
    }

    isUpdateUserInformation() {
        if (this.state.isUpdateUserInformation === true) {
            scrollToComponent(this.SuccessUpdate, { offset: -30, align: 'top', duration: 500 });
            return (
                <div id="successUpdateUserInformation" className="successUpdateUserInformation col-xs-12 col-md-8">
                    <div className="stepPersonalData addPersonalDataForm">
                        <img src={success}/>
                        <div>Kiitos! Tietosi on tallennettu.</div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="resultConfirmPageMore col-xs-12 col-md-8">
                    <div className="addPersonalDataFormTitle col-xs-12">
                        <img src={clipboardTodo} alt="clipboardTodo"/>Tämä näyttäisi olevan sinun ensimmäinen kerta meillä.
                    </div>
                    <div className="stepPersonalData addPersonalDataForm">
                        {(this.state.loader === true) ? <div className="localLoader"><div className="localSpinner"></div></div> : ''}
                        <div className="stepPersonalDataTitle">Täytä henkilötietosi:</div>
                        <div className="col-xs-6">
                            <div><label>Etuimi:</label></div>
                            <div className="inputBlock"><input value={GlobalStore.getInstance().data['userShortData'].userName} readOnly className="readOnlyInput" /></div>
                        </div>
                        <div className="col-xs-6">
                            <div><label>Sukunimi:</label></div>
                            <div className="inputBlock"><input value={GlobalStore.getInstance().data['userShortData'].userSurname} readOnly className="readOnlyInput"/></div>
                        </div>
                        <div className="col-xs-12">
                            <div><label>Sähköposti:</label></div>
                            <div className="inputBlock"><input ref="personalEmail" type="email"/></div>
                        </div>
                        <div className="col-xs-8">
                            <div><label>Osoite:</label></div>
                            <div className="inputBlock"><input ref="personalStreetName"/></div>
                        </div>
                        <div className="col-xs-4">
                            <div><label>Postinumero:</label></div>
                            <div className="inputBlock"><input ref="personalZipCode"/></div>
                        </div>
                        {/*місто*/}
                        <div className="col-xs-8">
                            <div><label>Kaupunki:</label></div>
                            <div className="inputBlock"><input ref="personalCity"/></div>
                        </div>
                        <div className="col-xs-12 fullWidthDesktop">
                            <div><label>Puhelinnumerosi:</label></div>
                            <div className="inputBlock"><input defaultValue={GlobalStore.getInstance().data['userShortData'].personalPhone} ref="personalPhone"/></div>
                        </div>
                    </div>
                    <div className="dataFormNavigation col-xs-12">
                        <div className="col-xs-6"></div>
                        <div className="col-xs-6"><div className="continueButton" onClick={this.savePersonalData}>Päivitä tiedot</div></div>
                    </div>
                </div>
            )
        }
    }

    generateActiveDayString(currentDate) {
        let currentDay = currentDate.getDate();
        let currentMonth = currentDate.getMonth() + 1;
        let currentYear = currentDate.getFullYear();

        if(currentDay < 10){
            currentDay = '0' + currentDay;
        }
        if(currentMonth < 10){
            currentMonth = '0' + currentMonth;
        }

        return currentDay + '.' + currentMonth + '.' + currentYear;
    }

    render() {
        let stepTimeData = GlobalStore.getInstance().data['stepTimeData'];
        let userShortData = GlobalStore.getInstance().data['userShortData'];
        let activeDate = new Date(stepTimeData.StartTime);
        let currentDay = activeDate.getDate();
        let currentMonth = activeDate.getMonth() + 1;

        if(currentDay < 10){
            currentDay = '0' + currentDay;
        }
        if(currentMonth < 10){
            currentMonth = '0' + currentMonth;
        }
        activeDate = currentDay + '.' + currentMonth + '.' + activeDate.getFullYear();

        let dataFromGlobalStore = GlobalStore.getInstance().data;

        let ifNewUser;
        if(GlobalStore.getInstance().data['ifNewUser'] === true) {
            ifNewUser = 'wrapperContainer showAddUserDataBlock';
        }else {
            ifNewUser = 'wrapperContainer hideAddUserDataBlock';
        }

        return (
            <div>

                <div className="resultConfirmPage col-xs-12">
                    <div className="wrapperContainer">
                        <div className="col-xs-12 col-md-6">
                            <img className="resultBigImage" src={resultLogo} alt="resultLogo"/>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className="resultConfirmSuccess">Onnistuit! <p style={{color:"red"}}>{GlobalStore.getInstance().data['FakeResponse']?"This was fake booking for dev env - no request to server was made, check ApiConnector":""}</p></div>
                            <div className="resultConfirmThank">Kiitos ajanvarauksestasi<br/><span> {this.generateActiveDayString(new Date(dataFromGlobalStore.stepTimeData.currentFreeTimeString)) + ', klo ' + dataFromGlobalStore.stepTimeData.activeFreeTime}</span></div>
                            <div className="resultConfirmSubInfo">Olemme lähettäneet ajanvarauksesta tekstiviestin.</div>

                            <div className="col-xs-12 resultConfirmButtonPart">
                                {/*THIS IS ADD TO CALENDAR BUTTON - YET TO BE IMPLEMENTED AND STYLES NEED TO BE ADJUSTED*/}
                                {/*<div className="col-xs-6 resultConfirmButtonLeft"><span>Tee kalenterimerkintä</span></div> */}
                                <div className="col-xs-12 dropdown dropdownCalendar">
                                    <button className="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown">Tee kalenterimerkintä</button>
                                    <div className="dropdownMenuContainer"></div>
                                    <ul className="dropdown-menu">
                                        <li className="appleCalendarButton" onClick={this.openAppleCalendar}><img src={appleIco} alt="appleCalendarIco" /> Apple Calendar</li>
                                        <li className="googleCalendarButton" onClick={this.openGoogleCalendar}><img src={googleIco} alt="googleCalendarIco" />  Google Calendar</li>
                                    </ul>
                                </div>
                                {/*THIS IS PRINT BUTTON - YET TO BE IMPLEMENTED AND STYLES NEED TO BE ADJUSTED*/}
                                {/*<div className="col-xs-6 resultConfirmButtonRight"><span>Tulosta tiedot</span></div>*/}
                                <div className="col-xs-12 orDiv"></div>
                                <div className="col-xs-6 resultConfirmButtonReset"><span onClick={this.clearCookiesAndRestart}><img src={clipboard} alt='clipboard'/>Varaa uusi aika</span></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xs-12 resultMoreInfoContainer" ref={(section) => { this.SuccessUpdate = section; }}>
                    <div className={ifNewUser}>
                        {/*start add user data info*/}
                        {/*TODO: по замовчуванню true*/}
                        {(GlobalStore.getInstance().data['ifNewUser'] === true) ? this.isUpdateUserInformation() : '' }
                        {/*start confirm info*/}
                        <div className="col-xs-12 col-md-4 fullReservationInfo">
                            <div className="resultConfirmSubTitle">Ajanvarauksen yhteenveto:</div>
                            <div className="stepPersonalData verifyContainer">
                                <div className="stepPersonalDataTitle">Ajanvaraustiedot:</div>
                                <div className="col-xs-12 col-md-6">
                                    <div><label>Palvelu:</label></div>
                                    <div className="resultDataBlock">{GlobalStore.getInstance().data['categoryName']}</div>
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <div><label>Hoitohenkilö:</label></div>
                                    <div className="resultDataBlock">{stepTimeData.activeDoctorName}</div>
                                </div>
                                <div className="col-xs-6 dataLeftPart">
                                    <div><label>Päivämäärä:</label></div>
                                    <div className="resultDataBlock">
                                        <div>{activeDate}</div>
                                        <div><span>{stepTimeData.activeDayName}</span></div>
                                    </div>
                                </div>
                                <div className="col-xs-6 rimeRightPart">
                                    <div><label>Aika:</label></div>
                                    <div className="resultDataBlock">
                                        <div>{stepTimeData.activeFreeTime}</div>
                                        <div><span>Kesto {stepTimeData.activeLength} min</span></div>
                                    </div>
                                </div>

                                <div className="col-xs-12 lastCol12">
                                    <div><label>Potilas:</label></div>
                                    <div className="resultDataBlock borderNone">{userShortData.userName} {userShortData.userSurname}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*start address part*/}
                </div>

                <div className="col-xs-12 mapsContainer">
                    <div className="resultConfirmSubTitle">Osoitteemme:</div>
                    <div className="col-xs-12 col-md-6 mapItem">
                        <div className="col-xs-12 ourAddressPart">
                            <div className="addressBlock">
                                <div className="col-xs-6"><div><img alt="location" src={location}/></div><a href="https://goo.gl/maps/VHJcaCyDxto">Liesikuja 4 A, 2 krs. 01600 Vantaa</a></div>
                                <div className="col-xs-6"><div><img alt="phone" src={phone}/></div><a href="tel:095666733">(09) 5666 733</a></div>
                            </div>
                        </div>
                        
                        <div className="mapLocation col-xs-12">
                            <MyMapComponent_1 key="map_1" />
                        </div>  
                    </div>

                    <div className="col-xs-12 col-md-6 mapItem">
                        <div className="col-xs-12 ourAddressPart">
                            <div className="addressBlock">
                                <div className="col-xs-6"><div><img alt="location" src={location}/></div><a href="https://goo.gl/maps/16dv8DcMd5PTxtGk8">Laulukuja 4, 00420 Helsinki</a></div>
                                <div className="col-xs-6"><div><img alt="phone" src={phone}/></div><a href="tel:095666733">(09) 5666 733</a></div>
                            </div>
                        </div>
                        <div className="mapLocation col-xs-12">
                            <MyMapComponent_2 key="map_2" />
                        </div>                        
                    </div>
                </div>

                {/*start map block*/}
                {/* <div className="mapLocation col-xs-12"> */}
                    {/*bootstrapURLKeys={{key: "AIzaSyB2-96ZO1tYcY0eZoChgLZzAW7IrG2t3VY"}}*/}
                {/* </div> */}
                {/*<div className="col-xs-12 goToHomePagePart" ><a href="#" className="continueButton" onClick={this.clearCookiesAndRestart}>Clear cookies</a></div>*/}
                <div className="col-xs-12 goToHomePagePart goToHomePagePartMobile"><a href="http://hammasoskari.com/" className="continueButton goToHomePage">Takaisin kotiin</a></div>
                <div className="col-xs-12 borderBottomBlue">
                    <div className="wrapperContainer">
                        <div className="col-xs-6"><img src={skariLogo}/></div>
                        <div className="col-xs-6 goToHomePagePart"><a href="http://hammasoskari.com/" className="continueButton goToHomePage">Takaisin kotiin</a></div>
                    </div>
                </div>

                <NotificationContainer/>
            </div>
        );
    }
}

export default ResultConfirmPage;



// WEBPACK FOOTER //
// ./src/components/resultConfirmPage/ResultConfirmPage.jsx